const DIALECTIC = Object.freeze({
  CONCEPT: "concept",
  NEGATION: "negation",
  SYNTHESIS: "synthesis",
});

const RESULT = "progression";

const COLORS = Object.freeze({
  BLACK: "#000000",
  YELLOW: "#fff59d",
  BLUE: "#64b5f6",
  GREEN: "#81c784",
  RED: "#e57373",
  PURPLE: "#ce93d8",
  ORANGE: "#ffb74d",
  INDIGO: "#7986cb",
  AMBER: "#ffd54f",
  LIGHTGRAY: "#e0e0e0",
  DEEPPURPLE: "#9575cd",
  DEEPORANGE: "#ff8a65",
  LIGHTBROWN: "#a1887f",
  GREYBLUE: "#b0bec5",
  WHITE: "#ffffff",
});

export { COLORS, DIALECTIC, RESULT };
